import {
  DefaultError,
  DefinedInitialDataOptions,
  QueryKey,
  useQuery,
} from '@tanstack/react-query';

import { FetchOptions, useFetch } from './useFetch';

export function useApiQuery<TResponse>(
  url: string,
  options?: DefinedInitialDataOptions<
    TResponse,
    DefaultError,
    TResponse,
    QueryKey
  >,
  fetchOptions?: FetchOptions
) {
  const fetchClient = useFetch();

  const response = useQuery({
    queryFn: () => fetchClient(url, fetchOptions),
    ...options,
  });

  return response;
}
